import {ShareLandMarketContract} from '#/contracts/ShareLandMarketContract';
import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {Nullable} from '#/types/helpers';
import {useQueries} from '@tanstack/react-query';

export const useLimitOrders = (
  limitOrderIds: readonly bigint[],
  sharelandMarketContract: Nullable<ShareLandMarketContract>,
) =>
  useQueries({
    queries: limitOrderIds
      .map(id => Number(id))
      .sort((a, b) => b - a)
      .map(id => ({
        queryKey: [baseKeysUseQuery.useLimitOrders, sharelandMarketContract?.land.id, id],
        queryFn: () => sharelandMarketContract!.orderById(id),
        enabled: !!sharelandMarketContract,
      })),
  });
